import { TYPE_PROPOSITION, TYPE_COMMANDE } from '@/configuration/devisConf';

export default function transformer(serverTableData) {
  if (serverTableData.query.cmdEtat) {
    serverTableData.query.etat = [serverTableData.query.cmdEtat];
    delete serverTableData.query.cmdEtat;
  }
  if (serverTableData.query.cmdCode) {
    serverTableData.query.code = serverTableData.query.cmdCode;
    delete serverTableData.query.cmdCode;
  }
  if (serverTableData.query.cmdCategorie) {
    serverTableData.query.categorieVente = [serverTableData.query.cmdCategorie];
    delete serverTableData.query.cmdCategorie;
  }
  if (serverTableData.query.montantHt) {
    serverTableData.query.auto = serverTableData.query.montantHt;
    delete serverTableData.query.montantHt;
  }
  if (serverTableData.query.cmdType) {
    serverTableData.query.type = serverTableData.query.cmdType === '1' ? TYPE_COMMANDE : TYPE_PROPOSITION;
    delete serverTableData.query.cmdType;
  }

  return serverTableData;
}



// WEBPACK FOOTER //
// ./src/services/devisCommandes/devisCommandeServerTableDataTransformer.js